import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/HideContentBlock.module.scss'

import { Container, Image } from 'react-bootstrap'

import GreenButton from './GreenButton'

class HideContentBlock extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      hidden: false
    }
  }

  hideText = () => {
    this.setState({
      hidden: !this.state.hidden
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data, className } = this.props,
    { hidden } = this.state

    return (
      <section className={`${styles.section} ${styles[className]}`}>
        <Container>
          <div className={styles.text}>
            {data?.title != `` ?
              <div className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            :
              <div dangerouslySetInnerHTML={{__html: data?.text}} />
            }
            <div className={styles.text_bc}>
              <GreenButton
                text={hidden ? `Показать содержимое` : `Скрыть содержимое`}
                width={174}
                action={() => this.hideText()}
              />
            </div>
          </div>
          {data?.title != `` &&
            <div className={styles.text2} dangerouslySetInnerHTML={{__html: data?.text}} />
          }
          {!hidden &&
            <>
              {data?.list.map( ( elm, index ) => (
                <div key={index} className={styles.listblock}>
                  <div className={styles.listblock_topline}>
                    <div className={styles.listblock_topline_left}>
                      <div className={styles.listblock_icon}>
                        <Image src={elm?.image} width={21} height={21} alt={elm?.name} />
                      </div>
                      <div dangerouslySetInnerHTML={{__html: elm?.name}} />
                    </div>
                    <div>{this.formatSlideNumber(index)}</div>
                  </div>
                  <div className={`${styles.listblock_text} listblock_text`} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              ))}
            </>
          }
        </Container>
      </section>
    )
  }
}

HideContentBlock.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string
}

HideContentBlock.defaultProps = {
  data: {},
  className: `top`
}

export default HideContentBlock